export function setLocal(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch {}
}

export function getLocal(key) {
  try {
    return localStorage.getItem(key);
  } catch {}
}